import {useUserPreferences} from '@data/queries/preferences/userPreferences.main'

export default function useDeliveryType() {
  const res = useUserPreferences()

  return res.deliveryType
}
